module.exports = __webpack_public_path__ + "static/soap-bubbles-f6088517af6712e2420cf04a652b1634.jpg";